import React from 'react'
import Icon from '@mdi/react'
import {
  mdiTools,
  mdiChevronLeft,
  mdiChevronRight,
} from '@mdi/js'
import '../../skins/studio.css'
import StudioTopBar from './StudioTopBar'
import StudioSeriesRail from './StudioSeriesRail'
import StudioToolsRail from './StudioToolsRail'

/**
 * Shell Studio Rail (desktop).
 * children = viewport clínico (buildLayoutGrid / overlays) — intocable.
 * Panel de voz: overlay absoluto (no ensancha el grid → el viewport no se desplaza).
 */
function StudioShell({
  leftCollapsed,
  rightCollapsed,
  hideToolsRail = false,
  title,
  subtitle,
  planLabel,
  loadIndicator,
  isFullscreen,
  onToggleMenu,
  onToggleFullscreen,
  onLayout,
  onToggleLeftRail,
  onToggleRightRail,
  bell,
  installBanner,
  showMenu,
  explorer,
  onSelectSeries,
  seriesColor,
  autoSelectFirstSeries,
  onAutoShowExplorer,
  explorerPinProps = null,
  toolsProps,
  voiceOpen = false,
  voicePanel = null,
  copilotOpen = false,
  copilotPanel = null,
  children,
}) {
  const effectiveRightCollapsed = hideToolsRail || rightCollapsed
  const shellClass = [
    'udv-studio-shell',
    leftCollapsed ? 'is-left-collapsed' : '',
    effectiveRightCollapsed ? 'is-right-collapsed' : '',
    hideToolsRail ? 'is-portal-no-tools' : '',
    voiceOpen ? 'is-voice-overlay' : '',
    copilotOpen ? 'is-copilot-overlay' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={shellClass} data-skin="studio">
      <StudioTopBar
        title={title}
        subtitle={subtitle}
        planLabel={planLabel}
        loadIndicator={loadIndicator}
        isFullscreen={isFullscreen}
        onToggleMenu={onToggleMenu}
        onToggleFullscreen={onToggleFullscreen}
        onLayout={onLayout}
        onToggleLeftRail={onToggleLeftRail}
        leftRailCollapsed={!!leftCollapsed}
        onToggleRightRail={hideToolsRail ? undefined : onToggleRightRail}
        rightRailCollapsed={!!effectiveRightCollapsed}
        hideRightRailToggle={!!hideToolsRail}
        bell={bell}
        installBanner={installBanner}
        showMenu={showMenu}
      />
      <div className="udv-studio-body">
        <aside className="udv-studio-left" aria-label="Series">
          <div className="udv-studio-left-inner">
            <StudioSeriesRail
              explorer={explorer}
              onSelectSeries={onSelectSeries}
              color={seriesColor}
              autoSelectFirstSeries={autoSelectFirstSeries}
              onAutoShowExplorer={onAutoShowExplorer}
              {...(explorerPinProps || {})}
            />
          </div>
        </aside>
        <main className="udv-studio-viewport">{children}</main>
        {!hideToolsRail ? (
          <aside
            className="udv-studio-right"
            aria-label="Herramientas"
            aria-hidden={!!effectiveRightCollapsed}
          >
            {!effectiveRightCollapsed ? (
              <>
                <div className="udv-studio-right-head">
                  <button
                    type="button"
                    className="udv-studio-right-collapse"
                    onClick={onToggleRightRail}
                    aria-label="Ocultar herramientas"
                    title="Ocultar herramientas"
                  >
                    <Icon path={mdiChevronRight} size={0.75} color="currentColor" />
                  </button>
                </div>
                <StudioToolsRail {...toolsProps} />
              </>
            ) : null}
          </aside>
        ) : null}
      </div>

      {voiceOpen && voicePanel ? (
        <div className="udv-studio-voice-overlay" aria-label="Notas de voz">
          {voicePanel}
        </div>
      ) : null}

      {copilotOpen && copilotPanel ? (
        <div className="udv-studio-copilot-overlay" aria-label="UDV AI Copilot">
          {copilotPanel}
        </div>
      ) : null}

      {!hideToolsRail && effectiveRightCollapsed ? (
        <button
          type="button"
          className="udv-studio-tools-notch"
          onClick={onToggleRightRail}
          aria-label="Mostrar herramientas"
          title="Herramientas"
        >
          <span className="udv-studio-tools-notch-face">
            <Icon path={mdiTools} size={0.72} color="currentColor" />
            <Icon path={mdiChevronLeft} size={0.65} color="currentColor" />
          </span>
        </button>
      ) : null}
    </div>
  )
}

export default StudioShell
